import React from 'react';
import Term from '../../components/term';

import './styles.scss';

export const TermsPage: React.FunctionComponent = () => {
  return <Term/>;
};
